export default __webpack_public_path__ + "static/media/Search_light.455c474e.svg";